import styled from 'styled-components';

const TrueIcon = styled.i`
  color: ${({ theme }) => theme.colors.positive};
`;

const FalseIcon = styled.i`
  color: ${({ theme }) => theme.colors.negative};
`;

type Props = {
  isValid: boolean;
};

function TrueFalseIcon({ isValid }: Props) {
  return isValid ? <TrueIcon className="pi pi-check-circle" /> : <FalseIcon className="pi pi-times-circle" />;
}

export default TrueFalseIcon;
